import { takeEvery, call } from 'redux-saga/effects';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../../shared/api/headers';
import { DO_SSO_LOGIN_URL, DEFAULT_BASE_URL } from '../../../shared/api/urls';
import { apiRequest } from '../../../shared/api';
import { DO_SSO_LOGIN } from '../../../actions/actionTypes';

function* doLoginAsync(action) {
    const { identityProvider } = action;
    const ssoLoginPayload = {
        type: 'portalUser',
        provider: identityProvider,
    };

    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: DEFAULT_BASE_URL,
        url: DO_SSO_LOGIN_URL,
        params: ssoLoginPayload,
    };
    try {
        const { data: { redirectUrl } } = yield call(apiRequest, requestConfig);

        if (redirectUrl) {
            window.location.replace(redirectUrl);
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}

export default function* watchDoLogin() {
    yield takeEvery(DO_SSO_LOGIN, doLoginAsync);
}
